export const HARDCODED_SURVEYS = {
  dailyCheckType: 'Atemnot',
  activityCheckType: 'Activity Check',
  prismaCheck: 'Prisma Check',
};
